const PROMISE_KEY = '__karrotCsRailsUjsPromise';

function finalizeRails(Rails) {
  if (!Rails) return Rails;
  window.Rails = window.Rails || Rails;

  if (!window._rails_loaded && typeof Rails.start === 'function') {
    Rails.start();
  }

  if (typeof document !== 'undefined' && document.readyState !== 'loading') {
    if (typeof Rails.refreshCSRFTokens === 'function') Rails.refreshCSRFTokens();
    if (typeof Rails.loadCSPNonce === 'function') Rails.loadCSPNonce();
  }

  return window.Rails;
}

export function ensureRailsUjs() {
  if (typeof window === 'undefined') return Promise.resolve(null);
  if (window._rails_loaded) return Promise.resolve(window.Rails || window.jQuery?.rails || null);
  if (window.jQuery?.rails) return Promise.resolve(window.jQuery.rails);
  if (window.Rails && typeof window.Rails.start === 'function') {
    try {
      window.Rails.start();
    } catch (error) {
      // If start throws due to duplicate load, return the existing Rails instance.
      if (window._rails_loaded) return Promise.resolve(window.Rails);
      throw error;
    }
    return Promise.resolve(window.Rails);
  }
  if (window[PROMISE_KEY]) return window[PROMISE_KEY];

  window[PROMISE_KEY] = import('@rails/ujs')
    .then((mod) => finalizeRails(mod?.default ?? mod))
    .catch((error) => {
      // If another bundle already attached UJS, don't crash on re-import.
      if (window._rails_loaded || window.Rails || window.jQuery?.rails) {
        return window.Rails || window.jQuery?.rails || null;
      }
      throw error;
    });

  return window[PROMISE_KEY];
}

export function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta?.getAttribute('content') || '';
}
